import script from "./TeachingSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachingSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./TeachingSettingsPage.vue?vue&type=style&index=0&id=0fed92d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fed92d3"]])

export default __exports__